import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Table} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-etl-popup-design-select-table-groupage',
    templateUrl: './etl-popup-design-select-table-groupage.component.html',
    styleUrls: ['./etl-popup-design-select-table-groupage.component.scss'],
    standalone: false
})
export class EtlPopupDesignSelectTableGroupageComponent implements OnChanges {
    @Input() display: boolean;
    @Input() tableGroupage: string;
    @Input() tables: Table[];
    listes: Table[] = [];
    selectedTable: Table;

    @Output() public modif = new EventEmitter<string>();

    validate = false;
    /** Posé par « Annuler » / « Valider » : `(onHide)` part aussi après eux, et ne doit pas émettre
     *  une seconde fois (§1.1). */
    private closedByAction = false;

  constructor() { }
    doCancel(): void {
        this.closedByAction = true;
        this.modif.emit(null);
    }

    doValidateAndClose(): void {
        this.closedByAction = true;
        this.modif.emit(this.selectedTable.code);
    }

    /**
     * La croix doit annuler comme « Annuler ». L'ancienne garde `if (this.display)` ne le permettait
     * pas : `[(visible)]` a déjà remis `display` à `false` quand `(onHide)` part, si bien que la croix
     * n'émettait rien — le parent restait en mode groupé sans table, et ne pouvait plus rouvrir la
     * modale (son `displayTableGroupage` restait à `true`).
     */
    onHideDialogParamField(event): void {
        if (!this.closedByAction) {
            this.modif.emit(null);
        }
        this.closedByAction = false;
    }
    onShowDialogParamField(event): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.tables) {
            this.selectedTable = null;
            this.listes = this.tables.filter(t => t.tableDependencies.findIndex(td => td.cardinalie === '0n01') > -1);
            //this.selectedTable = this.listes.find(t => t.code === this.tableGroupage);
        }
    }
}
